import request from "@/utils/server.js";
import { companies } from "@/api/json-data/json-data.js";
// 首页模块
// 获取官网后台首页数据
export function getHomeDataAPI(params) {
  return request({
    url: "/aitax/public/Register/getPhoneByUser",
    method: "get",
    params,
  });
}
// 企业官网查询轮播图，经典案例，双渠道服务列表 10-轮播图，20-经典案例，30-双渠道服务
export function getHomeBannerAPI(params) {
  return request({
    url: "/wx/company/ScdType/list",
    method: "get",
    params,
  });
}
// 获取我的资源企业列表（POST方法）
export function getCompanyListAPI(data) {
  return companies;
}


